import { createAction, props } from '@ngrx/store';

import { IResptSaveGoing } from '../../shared/models/Games.model';
import { IPopUpStatusParams, IRespGetModal, IRespGetPromotionModal, IUpdateTenderoPopUpParams } from '../../shared/models/PopUp.interface';

/**
 * Modal (Generic)
 */
export const statusModal = createAction(
    '[Modal] Check modal',
    props<IPopUpStatusParams>()
);

export const successStatusModal = createAction(
    '[Modal] Check modal Success',
    props<IRespGetModal>()
);

export const errorStatusModal = createAction(
    '[Modal] Check modal Error',
    props<{ payload: Error }>()
);

export const updateModal = createAction(
    '[Modal] Send modal',
    props<IUpdateTenderoPopUpParams>()
);

export const successUpdateModal = createAction(
    '[Modal] Send modal Success',
    props<IResptSaveGoing>()
);

export const errorUpdateModal = createAction(
    '[Modal] Send modal Error',
    props<{ payload: Error }>()
);